import { createBrowserClient } from '@supabase/ssr';
import type { SupabaseClient } from '@supabase/supabase-js';

let instance: SupabaseClient | null = null;

/**
 * Browser client must use @supabase/ssr so the session is stored in cookies.
 * Middleware uses cookies; plain supabase-js keeps the session in localStorage only,
 * so protected routes (e.g. /admin-portal) never see the user after login.
 */
export function createClient(): SupabaseClient {
  if (instance) return instance;
  instance = createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
  );
  return instance;
}
